import { defineComponent as d, computed as c, openBlock as i, createElementBlock as r, createElementVNode as t, toDisplayString as n, createCommentVNode as f, normalizeStyle as h, createStaticVNode as p } from "vue";
const _ = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "239448e7-6c68-4e7f-bf9c-c696d5a0732c" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), k = { mask: "url(#239448e7-6c68-4e7f-bf9c-c696d5a0732c)" }, u = { key: 0 }, v = /* @__PURE__ */ p('<path fill="#0052b4" d="m0 44.5 257.8-23.7L512 44.5v423l-252.5 26L0 467.5z"></path><circle cx="256" cy="256" r="122.4" fill="#eee"></circle><circle cx="256" cy="256" r="100.2" fill="#6da544"></circle><circle cx="256" cy="256" r="66.8" fill="#eee"></circle><path fill="#0052b4" d="M256 239.3 219.8 256v27.8l36.2 22.3 36.2-22.3V256z"></path><path fill="#ffda44" d="M219.8 222.6h72.4V256h-72.4z"></path><path fill="#a2001d" d="M0 0h512v44.5H0zm0 467.5h512V512H0z"></path>', 7), g = { fill: "none" }, x = ["r"], N = /* @__PURE__ */ d({
  __name: "bz",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(s) {
    const e = s, l = c(() => 512 + 2 * e.strokeWidth), o = c(() => -e.strokeWidth), a = c(() => 256 + e.strokeWidth / 2);
    return (y, z) => (i(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", k, [
        e.flagName ? (i(), r("title", u, n(e.flagName), 1)) : f("", !0),
        v
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: a.value,
          fill: "none",
          style: h({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, _));
  }
});
export {
  N as default
};
//# sourceMappingURL=bz-f597cab5.js.map
